module.exports = __webpack_public_path__ + "img/contact_01@2x.fdeb197d.png";